import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';

import { ContractsEffectsModule } from '@appStore/contracts/effects';
import { reducers } from '@appStore/contracts/reducers';
import * as fromServices from '@appStore/contracts/services';

export * from '@appStore/contracts/reducers';
export * from '@appStore/contracts/effects';
export * from '@appStore/contracts/actions';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('contracts', reducers), ContractsEffectsModule],
  providers: [fromServices.services]
})
export class ContractsStoreModule {}

